module.exports = __webpack_public_path__ + "img/japanese.b6baeb7d.svg";